var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.67678 9.15881C2.76917 9.06641 2.89622 9.01251 3.03096 9.01251H15.2504C15.4737 9.01251 15.5853 9.282 15.4275 9.43985L13.0136 11.8537C12.9212 11.9461 12.7942 12 12.6595 12H0.440012C0.21672 12 0.105075 11.7305 0.262919 11.5727L2.67678 9.15881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67626 0.146295C2.77251 0.053898 2.89955 0 3.03045 0H15.2499C15.4732 0 15.5848 0.26949 15.427 0.427334L13.0131 2.84119C12.9207 2.93359 12.7937 2.98749 12.6589 2.98749H0.439493C0.216202 2.98749 0.104556 2.718 0.2624 2.56015L2.67626 0.146295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0136 4.62371C12.9212 4.53131 12.7942 4.47742 12.6595 4.47742H0.440012C0.21672 4.47742 0.105075 4.74691 0.262919 4.90475L2.67678 7.31861C2.76917 7.41101 2.89622 7.4649 3.03096 7.4649H15.2504C15.4737 7.4649 15.5853 7.19542 15.4275 7.03757L13.0136 4.62371Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.3109,
    height: 12,
    fill: "white",
    transform: "translate(0.189758)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.1e47fd59a6c7ea5286134a37a7e9f9bd.svg";
export { ForwardRef as ReactComponent };